// extracted by mini-css-extract-plugin
module.exports = {"Component":"Header_Component__3YEd6"};